import api from "@/services/api";
import store from "@/store";

const state = {
  users: [],
};

const getters = {
  users: (s) => s.users,
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
};

const actions = {
  async getUsers({ commit }) {
    try {
      const user = store.getters['auth/user'];
      if (!user || user.userType !== "admin") throw new Error("Unauthorized");

      const res = await api.get("/users");
      commit("SET_USERS", res.data);
    } catch (error) {
      console.error("Error fetching users:", error.message);
      throw error;
    }
  },

  async getUserById(_, id) {
    try {
      const res = await api.get(`/users/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching user:", error.message);
      throw error;
    }
  },

  async createUser({ dispatch }, payload) {
    try {
      const user = store.getters['auth/user'];
      if (!user || user.userType !== "admin") throw new Error("Unauthorized");

      await api.post("/users", payload);
      dispatch("getUsers");
    } catch (error) {
      console.error("Error creating user:", error.message);
      throw error;
    }
  },

  async updateUser({ dispatch, commit }, { id, payload }) {
    try {
      const user = store.getters["auth/user"];
      if (!user) throw new Error("Unauthorized");

      const res = await api.put(`/users/${id}`, payload);

      if (user.userType === "admin") {
        if (user._id === id) {
          commit("auth/SET_USER", res.data.user, { root: true });
        }

        dispatch("getUsers");
      }
      else {
        commit("auth/SET_USER", res.data.user, { root: true });
      }

    } catch (error) {
      console.error("Error updating user:", error.message);
      throw error;
    }
  },

  async deleteUser({ dispatch }, id) {
    try {
      const user = store.getters['auth/user'];
      if (!user || user.userType !== "admin") throw new Error("Unauthorized");

      await api.delete(`/users/${id}`);
      dispatch("getUsers");
    } catch (error) {
      console.error("Error deleting user:", error.message);
      throw error;
    }
  },

  async deleteMyAccount() {
    const res = await api.delete("/users/me");
    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
